
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const MostlySunny = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="MostlySunny" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M9.5 0h1v2h-1zM14 5.5h2v1h-2zM5.4064155413 2.1069571335l.707242523-.7069710134L7.527600091 2.8144711659l-.7072425229.7069710134zm7.0762690044.7120732276l1.4145097236-1.4139173391.7069586696.7072548618-1.4145097236 1.4139173391zM12.943 11.039A2.572 2.572 0 0013 10.5a2.441 2.441 0 00-.249-1.041L13.89 10.6l.707-.707-1.414-1.415-.631.631a2.512 2.512 0 00-.742-.728A2.994 2.994 0 107.005 6c0 .047.012.09.014.136A3.951 3.951 0 006.005 6v-.5h-2v1h.1a3.985 3.985 0 00-2.1 3.5v.169a3 3 0 001 5.831h9.5a2.5 2.5 0 00.441-4.961zM10 4a2 2 0 010 4 1.961 1.961 0 01-.6-.1 4.009 4.009 0 00-1.3-1.3A1.976 1.976 0 018 6a2 2 0 012-2zm3.979 9.761A1.5 1.5 0 0112.5 15H3a2 2 0 01-.664-3.888l.7-.246L3 10.125V10a3 3 0 015.67-1.364l.029.057.387.758.848-.343a1.5 1.5 0 012.025 1.717l-.222 1.016 1.024.182a1.5 1.5 0 011.221 1.738z" />
</svg>
    </HvIconBase>
)};

MostlySunny.propTypes = HvIconBase.propTypes;

export default MostlySunny;